import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../_services/loader.service';
import { Observable } from 'rxjs';
import { TratamentoMensagensService } from '../_services/tratamento-mensagens.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(
    private loaderService: LoaderService,
    private tratamentoMensagensService: TratamentoMensagensService
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);

    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loaderService.isLoading.next(true);
    return new Observable((observer) => {
      const subscrition = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        (error) => {
          //alert('error' + error);
          this.removeRequest(req);
          if (error) {
            if (error.status == 404)
              observer.error(
                this.tratamentoMensagensService.tratarMensagem(
                  'Registro não encontrado'
                )
              );
            else
              observer.error(
                this.tratamentoMensagensService.tratarMensagem(error)
              );
          }
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      return () => {
        this.removeRequest(req);
        subscrition.unsubscribe();
      };
    });
  }
}
